import React from 'react'

const SingleRow = ({ pathway, totalNumberPapers, adSpecificPaperCount, pathwayScore, adWordScore, literatureRank, adSpecificPaperRank, prcPapersAd, perAnimal, perHuman, perGenetic, perModel }) => { // 

  return (<>
    <div className="excelRow" style={{ display: 'flex', justifyContent: 'space-between' }}>
      <p className="rowBox pathwayBox" style={{ color: 'black', width: '390px' }}>{ pathway }</p>
      <div className="afterPathway" style={{ display: 'flex', width: '1210px' }}>
        <p className="rowBox" style={{ width: 'calc(100%/11)' }}>{ totalNumberPapers }</p>
        <p className="rowBox" style={{ width: 'calc(100%/11)' }}>{ adSpecificPaperCount }</p>
        <p className="rowBox" style={{ width: 'calc(100%/11)' }}>{ pathwayScore }</p>
        <p className="rowBox" style={{ width: 'calc(100%/11)' }}>{ Number(adWordScore).toFixed(2) }</p>
        <p className="rowBox" style={{ width: 'calc(100%/11)' }}>{ literatureRank }</p>
        <p className="rowBox" style={{ width: 'calc(100%/11)' }}>{ adSpecificPaperRank }</p>
        <p className="rowBox" style={{ width: 'calc(100%/11)' }}>{ prcPapersAd }</p>
        <p className="rowBox" style={{ width: 'calc(100%/11)' }}>{ perAnimal }</p>
        <p className="rowBox" style={{ width: 'calc(100%/11)' }}>{ perHuman }</p>
        <p className="rowBox" style={{ width: 'calc(100%/11)' }}>{ perGenetic }</p>
        <p className="rowBox" style={{ width: 'calc(100%/11)' }}>{ perModel }</p>
      </div>
    </div>
  </>)
}

export default SingleRow

